var map = {
	"./Details.js": "86b2",
	"./HotRead.js": "53fb",
	"./Search.js": "92de",
	"./calculate.js": "a74d",
	"./collect.js": "eb64",
	"./indes.js": "761f",
	"./logins.js": "0ed7",
	"./newsFlash.js": "ed36",
	"./personal.js": "6263",
	"./templateClass.js": "f509",
	"./uploading.js": "9d4a",
	"./videoList.js": "92d1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a08a";